import { Flat } from "@/app/api/types";
import { Entity, IField } from "@/app/fields/types";
import { useFormContext } from "@saas-ui/forms";

export const useIsForm = <T extends Entity>(): ((
  field: IField<T>
) => boolean) => {
  const { watch } = useFormContext();
  const formValues = watch() as Flat<T>;

  const fn = ({ is_form }: IField<T>): boolean => {
    if (typeof is_form === "boolean") {
      return is_form;
    } else if (is_form === undefined) {
      return false;
    } else {
      const isFormFn = eval(is_form) as (value: Flat<T>) => boolean;
      return isFormFn(formValues);
    }
  };

  return fn;
};
